import React, { ButtonHTMLAttributes, ReactNode, Ref, forwardRef } from 'react'
import { nanoid } from 'nanoid'
import S from './Button.styles'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  id?: string
  children: ReactNode
  color?: 'primary' | 'secondary' | 'white' | 'black'
  /** When provided the button will be treated as a React Router <Link /> element */
  to?: string
  /** Callback invoked when the button is clicked */
  onClick?: () => void
}

const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
  ({ id = nanoid(), children, disabled = false, type = 'button', to = undefined, color = 'primary', onClick }, ref) => {
    const click = () => {
      onClick?.()
    }

    if (to) {
      return (
        <S.ButtonLink
          id={id}
          className={color}
          to={to}
          onClick={click}
          tabIndex={0}
          ref={ref as Ref<HTMLAnchorElement>}>
          {children}
        </S.ButtonLink>
      )
    }

    return (
      <S.Button
        id={id}
        className={color}
        type={type}
        onClick={click}
        disabled={disabled}
        tabIndex={0}
        ref={ref as Ref<HTMLButtonElement>}>
        {children}
      </S.Button>
    )
  }
)

export default Button
